// removed by extract-text-webpack-plugin
module.exports = {"button":"b6UQymTVYWkNTpLNETkhK","done":"_1TZU0grdr5UygggGk5FL9f","subtitle":"_29oGHnPP-wkE0IX0bqraPX"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ResetPasswordPage/ResetPasswordPage.css
// module id = 653
// module chunks = 3